import React from 'react';

export default React.createContext({
  uri: process.env.REACT_APP_SPINQUE_API_ENDPOINT,
  environment: process.env.REACT_APP_SPINQUE_API_ENVIRONMENT,
});
